import { position } from '@chakra-ui/system';

export const activeLabelStyles = {
  // transform: 'scale(0.85) translateY(-24px)',
  // marginInlineStart: 0,
  // paddingInlineStart: 0,
};

export const form = {
  baseStyle: {
    requiredIndicator: {
      color: 'inherit',
    },
  },

  variants: {
    floating: {
      container: {
        // backgroundColor: 'red',
        position: 'relative',
        // marginTop: '6px',

        // _focusWithin: {
        //   label: {
        //     ...activeLabelStyles,
        //   },
        // },
        // 'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label': {
        //   ...activeLabelStyles,
        // },
        label: {
          position: 'absolute',
          top: -5,
          // left: 0,
          // zIndex: 2,
          // position: 'absolute',
          // backgroundColor: 'white',
          // pointerEvents: 'none',
          // whiteSpace: 'nowrap',
          // mx: 3,
          // px: 1,
          // my: 2,
          // transition: 'all ease .3s',
          // transformOrigin: 'left top',
          // _dark: {
          // backgroundColor: 'transparent',
          // },
        },
      },
    },
  },
};
